export class MailStatus {
  public id: number;
  public mailId: number;
  public statusId: number;
  public description?: string;
  public creationDate?: string;
}
